import { ANNOUNCEMENT } from "@/config/site";

export function AnnouncementBar() {
  if (!ANNOUNCEMENT || !ANNOUNCEMENT.trim()) return null;
  return (
    <div
      data-testid="announcement-bar"
      className="bg-nm-red px-4 py-2 text-center text-xs font-medium text-white sm:text-sm"
    >
      {ANNOUNCEMENT}
    </div>
  );
}
